<template>
  <div>
    <div class='finish_room'>
      <div class='finish_room2'>
        <div class='room_add_img' :class="imageUrl ? 'solid_img' : ''">
          <span :class="imageUrl ? 'full_span' : 'full_add'">
            <img :class="imageUrl ? 'full_img' :''" :src="imageUrl" v-if="imageUrl">
          </span>
          <input @change='fileChange' type="file">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: {
    imageUrl: {
      type: String
    }
  },
  data() {
    return {
      logoshow: false,
      xcxshow: false,
      centerDialogVisible: false,
      defaultImglogo: '', // 店铺默认 logo
      defaultImgxcx: '', // 店铺默认 logo
      imgsrc: ''
    }
  },
  methods: {
    fileChange(e) {
      let logofile = e.target.files[0]
      this.$emit('confirm', logofile)
    }
  }
}
</script>
<style lang="scss" scoped>
.finish_room {
  display: inline-block;
}

.finish_room2 {
  width: 100%;
  height: auto;
  padding-top: 15px;
  padding-bottom: 15px;
  display: flex;
  align-items: center;
}

.sizepx{
  vertical-align: bottom;
  padding-bottom: 6px;
  margin-left: 5px;
  display: inline-block;
}

.finish_room2 .room_img{
  width: 150px;
  height: 100px;
  margin-right: 10px;
  position: relative;
  overflow: hidden;
}
.finish_room2 .room_img img{

  width: 100%;
  height: 100%;
}
.finish_room2>.room_img span{
  position: absolute;
  width: auto;
  height: auto;
  right: 5px;
  bottom:3px;
}

.room_add_img{
  width: 100px;
  height: 100px;
  border: 1px dashed #dcdfe6;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;
  border-radius: 3px;
}
.room_add_img >span:nth-child(1){
  margin-top: 35px;
  width: 40px;
  height: 40px;
  overflow: hidden;
  display: inline-block;
  text-align: center;
}
.room_add_img >span:nth-child(2){
  margin-bottom: 10px;
}

.room_add_img input{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 99999;
  opacity: 0;
}
.room_add_img img {
  width: 20px;
  height: 20px;
}
.room_add_img.solid_img {
  border:1px solid #dcdfe6;
}
.room_add_img >span.full_span {
  width: 98px;
  height: 98px;
  overflow: hidden;
  display: inline-block;
  text-align: center;
  margin-top: 0px;
}
.room_add_img >span.full_add {
  margin-top: 30px;
  background:url('https://img-shop.qmimg.cn/s1000184/images/2019/10/24/586c0545a5382e79.png') center no-repeat;
  background-size: 38px 38px;
}
.room_add_img .full_img {
  width: 98px;
  height: 98px;
  border-radius: 3px;
}

.kuodaimg{
   display: inline-block;
   max-width:100%;
   max-height:465px;
}

#Imglogo, #Imgxcx{
  display: none;
}

.logoimg{
  width: 100%;
  height: 100%;
}
.file {
  outline: none;
  border:none;
  background: #67BEF4;
  border-radius: 4px;
  padding: 4px 12px;
  cursor:pointer;
  color: #fff;
  font-size:18px;
  line-height: 20px;
  vertical-align: middle;
}
.logotest{
  display: inline-block;
}
.imgdiv{
  width: 100px;
  height: 100px;
  margin-left: 10px;
  z-index: 99;
  border: 1px solid #dcdfe6;
  position: relative;
  border-radius: 3px;
  img {
    border-radius: 3px;
  }
}
</style>